import { api, ApiResponse } from './api';
import { PaginationParams } from '@/lib/types';

export interface PractitionerStaff {
  id: string
  status: string
  full_name: string
  first_name?: string
  last_name?: string
  email?: string
  phone?: string
  phone_number?: string
  clinic_id?: string
  is_clinic_admin?: boolean
  rpa_status?: string
  rpa_progress?: number
  created_at?: string
  user_id?: string
  clinic?: { name?: string; id?: string }
  user?: { status?: string; id?: string }
}

export const practitionerStaffService = {
  getClinicPractitionerStaff: (clinicId: string, params: any) => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params?.status) queryParams.append('status', params.status);
    return api.get<ApiResponse<{ practitionerStaff: PractitionerStaff[], pagination: PaginationParams }>>(`clinic/${clinicId}/practitioner-staff?${queryParams.toString()}`);
  },
  createClinicPractitionerStaff: (clinicId: string, practitionerStaffData: any) => {
    return api.post(`clinic/${clinicId}/practitioner-staff`, practitionerStaffData);
  },
  archiveClinicPractitionerStaff: (clinicId: string, practitionerStaffId: string) => {
    return api.patch(`clinic/${clinicId}/practitioner-staff/${practitionerStaffId}/archive`);
  },
  restoreClinicPractitionerStaff: (clinicId: string, practitionerStaffId: string) => {
    return api.patch(`clinic/${clinicId}/practitioner-staff/${practitionerStaffId}/restore`);
  },
};